import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from "@angular/core";

@Component({
    selector: "h-grid-edito-content",
    templateUrl: "./grid-edito-content.component.html",
    styleUrls: ["./grid-edito-content.component.scss"],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridEditoContentComponent {
    @Input({ required: true })
    public innerHTML!: string;
}
